import { Injectable } from '@angular/core';
import { CanLoad, Route, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PrivilegeGuard implements CanLoad {
  constructor(public authService: AuthService, private router: Router) {}

  canLoad(route: Route): boolean {
    const expectedRole = route.data.expectedRole;
    const hasPrivilege = this.authService.hasPrivilege(expectedRole);
    if (!hasPrivilege) {
      this.router.navigate(['/']);
    }

    return hasPrivilege;
  }
}
